"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@emotion/react");
var makeLinkStyling = function (_a) {
    var _b, _c;
    var variant = _a.variant;
    var theme = (0, react_1.useTheme)();
    return (0, react_1.css)(__assign(__assign(__assign({}, (variant === 'button' && (_b = {
            color: theme.mvf.palette.text.secondaryTextColor,
            fontFamily: theme.mvf.typography.fontFamily,
            fontSize: theme.mvf.fontSize.little
        },
        _b[theme.breakpoints.up('tabletSmall')] = {
            fontSize: theme.mvf.fontSize.mini,
        },
        _b))), (variant === 'footer' && (_c = {
            color: theme.mvf.palette.text.primaryTextColor,
            cursor: 'pointer',
            fontSize: theme.mvf.fontSize.tiny
        },
        _c[theme.breakpoints.up('tabletSmall')] = {
            fontSize: theme.mvf.fontSize.little,
        },
        _c.fontFamily = theme.mvf.typography.fontFamily,
        _c.textDecoration = 'underline',
        _c))), (variant === 'text' && {
        color: theme.mvf.palette.text.primaryTextColor,
        fontFamily: theme.mvf.typography.fontFamily,
        fontSize: theme.mvf.fontSize.medium,
    })));
};
exports.default = makeLinkStyling;
//# sourceMappingURL=makeLinkStyling.js.map